module.exports = __webpack_public_path__ + "static/img/劳资模块.561dab0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/劳资模块.png
// module id = JcLH
// module chunks = 1